import type { SortDto, TableColumnSystemField } from '@tempo-io/roadmap-dto';

const COLUMN_TYPE_TO_ORDER_KEY: Partial<Record<TableColumnSystemField, string>> = {
  name: 'name',
  id: 'id',
  externalKey: 'externalKey',
  status: 'status',
  itemType: 'itemType',
  estimation: 'estimation',
  estimationScheme: 'estimationScheme',
  timeSpent: 'timeSpentSeconds',
  doneDate: 'doneDateTime',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  earliestStartDate: 'earliestStartDateTime',
  deadlineDate: 'deadlineDateTime',
  plannedStartDate: 'plannedStartDateTime',
  plannedFinishDate: 'plannedFinishDateTime',
  expectedStartDate: 'forecastedStartDateTime',
  expectedFinishDate: 'forecastedFinishDateTime',
  latestFinishDate: 'latestFinishDateTime',
};

export const isItemFieldSortable = (
  type: TableColumnSystemField,
  sortableKeys: ReadonlySet<string>,
): boolean => {
  const key = COLUMN_TYPE_TO_ORDER_KEY[type];
  return key != null && sortableKeys.has(key);
};

export const buildOrderString = (
  sort: SortDto | undefined,
  sortableKeys: ReadonlySet<string>,
): string | undefined => {
  if (!sort?.type) return undefined;
  const direction = sort.order === 'desc' ? 'DESC' : 'ASC';

  if (sort.type === 'customField') {
    return sort.customFieldId ? `customField(${sort.customFieldId}) ${direction}` : undefined;
  }

  const key = COLUMN_TYPE_TO_ORDER_KEY[sort.type as TableColumnSystemField];
  if (!key || !sortableKeys.has(key)) return undefined;

  if (key === 'itemType' && sortableKeys.has('itemLevel')) {
    return `itemLevel ${direction},itemType ${direction}`;
  }

  return `${key} ${direction}`;
};
